import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Button, Col, Input, message, Row } from 'antd';
import { spacing } from '../../lib/theme';
import { replyReviewComment, editReviewComment } from '../../actions';

const { TextArea } = Input;

class AddReply extends Component {
    constructor(props) {
        super(props);
        this.state = { reply: props.comment && props.comment.comment || '' };
    }

    onReplyChange = (event) => {
        this.setState({ reply: event.target.value });
    }

    cancelReply = () => {
        this.props.closeAddReply();
    }

    addReply = () => {
        const { userDetails, review, type } = this.props;
        if (!userDetails || !userDetails.uid) {
            message.info('Please sign in to reply.');
            return;
        }
        const { reply } = this.state;
        if (!reply) {
            this.props.closeAddReply();
            return;
        }
        if (type === 'mainReply') {
            this.props.replyReviewComment(review, '', reply, userDetails);
            this.props.closeAddReply();
        } else if (type === 'commentReply') {
            console.dir(reply);
            const { commentId } = this.props;
            this.props.replyReviewComment(review, commentId, reply, userDetails);
            this.props.closeAddReply();
        }
    }

    editReply = () => {
        const { userDetails, review, type } = this.props;
        if (!userDetails || !userDetails.uid) {
            message.info('Please sign in to reply.');
            return;
        }
        const { reply } = this.state;
        if (!reply) {
            this.props.closeAddReply();
            return;
        }
        if (type === 'mainReply') {
            // this.props.replyReviewComment(review, '', reply, userDetails);
            // this.props.closeAddReply();
        } else if (type === 'commentReply') {
            console.dir(reply);
            const { commentId } = this.props;
            this.props.editReviewComment(review, commentId, reply, userDetails);
            this.props.closeAddReply();
        }
    }

    render() {
        const { comment } = this.props;
        const { reply } = this.state;
        console.dir(comment);
        return (
            <div style={{ marginTop: `${spacing()}` }}>
                <TextArea
                    value={reply}
                    onChange={this.onReplyChange}
                    placeholder="Add a public reply..."
                />
                <Row style={{ marginTop: `${spacing()}` }}>
                    <Col style={{ textAlign: 'right' }} xl={3} offset={18}>
                        <Button type='outline' onClick={this.cancelReply}>Cancel</Button>
                    </Col>
                    <Col style={{ textAlign: 'right' }} xl={3}>
                        {(comment && comment.postedTime) ? <Button disabled={reply.length < 1} type='primary' onClick={this.editReply}>Edit</Button> :
                            <Button disabled={reply.length < 1} type='primary' onClick={this.addReply}>Reply</Button>}
                    </Col>
                </Row>
            </div>
        )
    }
}

AddReply.defaultProps = {
    type: 'mainReply',
}

AddReply.propTypes = {
    type: PropTypes.string,
    closeAddReply: PropTypes.func,
    replyReview: PropTypes.func,
    replyReviewComment: PropTypes.func,
    editReviewComment: PropTypes.func,
    userDetails: PropTypes.object,
    review: PropTypes.object,
    commentId: PropTypes.string,
    comment: PropTypes.object,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        editReviewComment: bindActionCreators(editReviewComment, dispatch),
        replyReviewComment: bindActionCreators(replyReviewComment, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AddReply);
